import { Navigate } from 'react-router-dom';
import { SUPER_ADMIN_NAV } from '../../lib/nav-config';
import { useAuthStore } from '../../store/auth.store';
import { AppShell } from './AppShell';

/**
 * AdminLayout — shell pra rotas `/admin/*` (SUPER_ADMIN). O brand é
 * resolvido pelo AppShell via useBrandingStore + sufixo "— Admin" pro
 * SUPER_ADMIN ([UI-TENANT]).
 *
 * [fix cold-start] Defense-in-depth: bloqueia o shell antes de cada
 * `<AdminRoute>` filho rodar. Cada rota `/admin/*` já está envolvida
 * em `<AdminRoute>` (redireciona pra /login se sem sessão; pra
 * /dashboard se perfil != SUPER_ADMIN), mas redundância aqui:
 *  - Evita montar o shell admin (sidebar/topbar/breadcrumb) durante o
 *    1º paint quando alguém acessa /admin/* sem sessão via deep-link.
 *  - Em conjunto com o gate de hidratação do App, garante que a
 *    decisão acontece com o estado canônico do auth, sem pisca.
 */
export function AdminLayout(): JSX.Element {
  const usuario = useAuthStore((s) => s.usuario);
  if (!usuario) return <Navigate to="/login" replace />;
  if (usuario.perfil !== 'SUPER_ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }
  return <AppShell nav={SUPER_ADMIN_NAV} />;
}
